<template>
  <el-dialog
    width="700px"
    custom-class="ap-recycle-detail"
    :visible.sync="dialogShow"
    :modal-append-to-body="true"
    :destroy-on-close="true"
    append-to-body
    title="接入点详情"
  >
    <div v-loading="loading" style="width: 500px; margin: 0px auto 20px">
      <el-form ref="apDetail" class="display-form mt" label-position="left" label-width="120px">
        <el-form-item label="接入点编号">
          <el-col :span="24">{{ ap.simid }}</el-col>
        </el-form-item>
        <el-form-item label="绑定设备">
          <el-col :span="24">{{ ap.equip_name }}</el-col>
        </el-form-item>
        <el-form-item label="绑定设备模型">
          <el-col :span="24">{{ ap.dev_name }}</el-col>
        </el-form-item>
        <el-form-item label="终端型号">
          <el-col :span="24">{{ ap.dtu_model }}</el-col>
        </el-form-item>
        <el-form-item label="Mac地址">
          <el-col :span="24">{{ ap.mac }}</el-col>
        </el-form-item>
        <el-form-item label="物联卡ICCID">
          <el-col :span="24">{{ ap.iccid }}</el-col>
        </el-form-item>
        <el-form-item label="激活时间">
          <el-col :span="24">{{ ap.first_activation | parseTime('{y}/{m}/{d}') }}</el-col>
        </el-form-item>
        <el-form-item label="到期时间">
          <el-col :span="24">{{ ap.expire_day | parseTime('{y}/{m}/{d}') }}</el-col>
        </el-form-item>
        <el-form-item label="注销时间">
          <el-col :span="24">
            <span class="mr">{{ ap.deletetime | parseTime('{y}/{m}/{d}') }}</span>
            <span v-if="ap.delete_way == 2">
              <el-tag type="warning">主动添加</el-tag>
            </span>
            <span v-else>
              <el-tag type="info">自动回收</el-tag>
            </span>
          </el-col>
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import { apGetApi } from "@/api/ap/apApi";
export default {
  components: {},
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    simid: {
      type: [String, Number],
      default: 0,
    },
  },
  data() {
    return {
      loading: false,
      ap: {},
    };
  },
  computed: {
    dialogShow: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },
  },
  created() {
    this.fetchData();
  },

  methods: {
    fetchData() {
      this.loading = true;
      apGetApi({ simid: this.simid }).then((res) => {
        this.loading = false;
        if (!res.errno) {
          this.ap = Object.assign({}, res.data);
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
